import React from "react";

import LoginRegisterPasswords from "../../components/login-register-passwords/login-register-passwords.component";
const RegisterPass = () => {
  return <LoginRegisterPasswords register='pass' />;
};
export default RegisterPass;
